import { z } from "zod";
import { Timestamps } from "../../common/index.ts";
import { TranslationKeySchema } from "../../i18n/index.ts";
import { DocumentTypeDto } from "../document-types/document-types.schema.ts";
import {
  DocumentTypeId,
  EntityId,
  FsmTranslationsSchema,
  StateId,
  CustomerId,
} from "../fsm.schema.ts";

/**
 * @description A State represents a specific status that a Document can be in within the FSM.
 */
export const StateDto = z
  .object({
    id: StateId,
    customerId: CustomerId,
    documentTypeId: DocumentTypeId,
    name: TranslationKeySchema,
    // BEL-651: stable identifier, independent of the editable Spanish name.
    // Nullable — matches the DB column; a customer-authored state created
    // via the admin UI (no key input there) legitimately has none.
    key: z.string().nullable(),
    description: z.string().nullable(),
    isInitial: z.boolean(),
    isFinal: z.boolean(),
    notifyEntityIds: z.array(EntityId).nullable(),
    translations: FsmTranslationsSchema.nullable(),
  })
  .merge(Timestamps);

export type StateDto = z.infer<typeof StateDto>;

export const StateHydrated = StateDto.extend({
  documentType: DocumentTypeDto,
});

export type StateHydrated = z.infer<typeof StateHydrated>;

export const CreateStateInput = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  documentTypeId: DocumentTypeId,
  isInitial: z.boolean().optional(),
  isFinal: z.boolean().optional(),
  notifyEntityIds: z.array(EntityId).nullable().optional(),
  translations: FsmTranslationsSchema.optional(),
});
export type CreateStateInput = z.infer<typeof CreateStateInput>;

export const UpdateStateInput = z.object({
  name: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
  isInitial: z.boolean().optional(),
  isFinal: z.boolean().optional(),
  notifyEntityIds: z.array(EntityId).nullable().optional(),
  translations: FsmTranslationsSchema.nullable().optional(),
});
export type UpdateStateInput = z.infer<typeof UpdateStateInput>;
